export const meta = {
  id: "FW-40",
  name: "Wayfound",
  slug: "wayfound",
  title: "Wayfound — a Fable World: travel storefront",
  description:
    "An original travel storefront designed by Fable: luggage-tag card stacks that separate in depth and slam into stamped parcels."
} as const;

export default meta;
